import { lory } from 'lory.js';
import initializeComponent from './Shared/react-initialize';
import Product360 from './product_360';
import { addProduct } from './Shared/add_to_cart';
import { recordAddToCart, recordProductView } from './product_analytics';
import InternationalBuyBox from './international_buy_box';
import setupStatuses from './Shared/status_es6';
import showProp65Warning from './prop65';
import { setSelectedOptionid } from './shared-state.js';
import DevicePartCompatibility from './device_part_compatibility.tsx';

import './hover_zoom';
import './Product/shipping_flag_notice';
import './ProductNote/index.js';
import './ProductReviews/stars.js';
import './ProductReviews/reviews.js';
import './Product/related-products.js';

onDomReady(setupStatuses);

initializeComponent('DevicePartCompatibility', DevicePartCompatibility);

// We don't need to wait for the DOM to load before making an API request.
const intlBuyBox = new InternationalBuyBox(App.productcode);

onDomReady(function() {
   // Setup Video Events
   (function() {
      $$('.videoBox').set('style', '');

      window.addEvent('click:relay(.js-screen-size-item)', function(ev, el) {
         var size = el.get('data-screen-size');
         $$('.js-video-container').set('data-video-size', size);
         $$('.js-screen-size-item').removeClass('active');
         el.addClass('active');
      });
   })();

   // Setup Truncate Toggle Events
   (function() {
      var toggleTruncation = function(toggleButtons, listContainer) {
         listContainer.toggleClass('truncated');
         toggleButtons.toggleClass('hidden');
         toggleButtons[0].focus();
      };

      var setupHiddenCompatibleDeviceToggle = (function() {
         var toggleButtons = $$('.js-toggle-compatible-device-chart');
         var toggleContainer = $E('.js-compatible-device-table');

         toggleButtons.addEvent('click', function(ev) {
            toggleTruncation(toggleButtons, toggleContainer);
         });
      })();

      var setupStoryListToggle = (function() {
         var toggleButtons = $$('.js-toggle-stories');
         var toggleContainer = $E('.js-story-list');

         toggleButtons.addEvent('click', function(ev) {
            toggleTruncation(toggleButtons, toggleContainer);
         });
      })();
   })();

   // Setup Story Events
   (function() {
      var storyContents = $$('.js-story-content');
      var storyModalImages = $$('.js-modal-image-view');

      storyModalImages.each(function(imageEl) {
         imageEl.addModalImage();
      });

      storyContents.each(function(storyEl) {
         var truncatedDiv = storyEl.getElement('.js-truncated-story');

         if (truncatedDiv) {
            // The content exceeds the truncated length and has both full and
            // truncated versions in the template.
            var truncatedDivEnd = truncatedDiv.getElement('p:last-child');
            var fullContentDiv = storyEl.getElement('.js-full-story');

            if (truncatedDivEnd) {
               var readMore = new Element('span', { class: 'read-more' });
               readMore.set('text', ' ' + _js('Read More'));
               readMore.inject(truncatedDivEnd, 'bottom');

               var readLess = new Element('span', { class: 'read-less' });
               readLess.set('text', ' ' + _js('Read Less'));
               readLess.inject(fullContentDiv, 'bottom');

               $$([readLess, readMore]).addEvent('click', function() {
                  $$([truncatedDiv, fullContentDiv]).toggleClass('hidden');
               });
               // The content is short enough that it has no truncated version
            } else {
               fullContentDiv.toggleClass('hidden');
            }
         }
      });
   })();

   // Setup Product Carousel Events
   (function() {
      $$('.js-carousel-btn').addEvent('click', function animateCarousel() {
         var direction = this.get('data-dir');
         var container = this.getParent().getElement('.js-carousel-row');
         // We could look it up by using getStyle() on one of the elements
         // but it ends up with more code and ends up a pixel short anyway.
         var itemMargin = 22;
         // We have to scroll a whole container width + the margin between the
         // items to get the left edge of the next item to line up when it's
         // done moving
         var scrollAmount = container.getSize().x + itemMargin;
         var newX = container.getScroll().x + direction * scrollAmount;
         var nextScroll = newX + scrollAmount;

         var carouselNext = container.getSiblings('.js-carousel-next');
         var carouselPrev = container.getSiblings('.js-carousel-prev');

         carouselNext.toggleClass('limit', nextScroll >= container.scrollWidth);
         carouselPrev.toggleClass('limit', newX <= 0);

         TweenLite.to(container, 0.3, { scrollTo: { x: newX } });
      });
   })();

   // Setup Prop 65 Warning
   Geo.locate(showProp65Warning);

   var ProductImageHandler = new Class({
      initialize: function(selectedOptionid) {
         this.activeImageContainer = $$('.active-image-container');
         this.activeImageStatic = $E('.active-image-static');
         this.thumbnails = $$('.product-page-thumbnail');
         this.thumbnailsStatic = $$('.product-page-thumbnail-static');
         this.thumbnail360 = $E('.product-page-thumbnail-360');
         this.thumbnailSelectedClass = 'product-page-thumbnail-selected';

         var initialThumbnail = this.getFirstThumbnailFromOptionid(selectedOptionid);
         var initialIndex = initialThumbnail ? this.getIndexOfThumbnail(initialThumbnail) : 0;
         this.productImageMobileHandler = new ProductImageMobileHandler(initialIndex);

         if (App.guid360) {
            this.activeImage360 = new Product360(
               $E('.active-image-360 .product-360'),
               App.directory360,
               'desktop'
            );

            this.activeImage360.on();
         }

         this.thumbnails.each(thumbnail => {
            thumbnail.addEvent('click', ev => {
               this.selectThumbnail(thumbnail);
            });
         });

         this.thumbnailsStatic.each(this.preloadStandardImageFromThumbnail);
      },

      /*
       * Preloads standard sized image of a thumbnail
       */
      preloadStandardImageFromThumbnail: function(thumbnail) {
         var src = thumbnail.get('data-standard');
         if (src != 'false') {
            new Element('div', {
               src: src,
            });
         }
      },

      /**
       * Returns a list of optionids we have thumbnails for.
       */
      getThumbnailOptionids: function() {
         return this.thumbnailsStatic.map(function(thumbnail) {
            return parseInt(thumbnail.get('data-optionid'), 10);
         });
      },

      /*
       * Selects a thumbnail and deselects a previously selected thumbnail.
       * Fires toggleActiveImageContainer.
       * Fires setActiveImageStaticFromThumbnail is a static thumbnail is selected.
       * Updates the mobile slider to the selected thumbnail.
       */
      selectThumbnail: function(thumbnail) {
         if (!thumbnail) {
            return;
         }
         var thumbnailIs360 = thumbnail === this.thumbnail360;
         this.thumbnails.removeClass(this.thumbnailSelectedClass);
         thumbnail.addClass(this.thumbnailSelectedClass);
         this.toggleActiveImageContainer(thumbnailIs360);

         if (!thumbnailIs360) {
            this.setActiveImageStaticFromThumbnail(thumbnail);
         }

         this.productImageMobileHandler.slideTo(this.getIndexOfThumbnail(thumbnail));
         window.updateMainImage();
      },

      /*
       * Toggles between showing the 360 components and the static images.
       * true: show 360, turn on 360
       * false: show static, turn off 360
       */
      toggleActiveImageContainer: function(bool) {
         if (App.guid360) {
            var turnOn360 = bool === undefined ? this.activeImage360.getState() === 'off' : bool;
            this.activeImageContainer.toggleClass('active-image-container-show-360', turnOn360);
            this.activeImage360.toggle(turnOn360);
         }
      },

      /*
       * Sets element in the activeImageStatic from a thumbnailStatic.
       */
      setActiveImageStaticFromThumbnail: function(thumbnail) {
         var optionid = thumbnail.get('data-optionid');
         var src = thumbnail.get('data-standard');
         var altText = thumbnail.get('data-alt-text');
         var activeImage = this.activeImageStatic;
         var srcset = '';

         activeImage.set('data-optionid', optionid);

         if (src != 'false') {
            var zoomsrc = thumbnail.get('data-zoomsrc');

            if (zoomsrc) {
               srcset = zoomsrc + ' 2000w,';
            }

            srcset += src + ' 520w';

            activeImage.set({
               srcset: srcset,
               alt: altText,
               src: src,
               'data-full-width': thumbnail.get('data-zoomwidth'),
               'data-full-height': thumbnail.get('data-zoomheight'),
               'data-zoomsrc': thumbnail.get('data-zoomsrc'),
            });
         }
      },

      /*
       * Gets the first thumbnail that matches an optionid, falling back to the
       * image with data-optionid=0. This is either the product-level image or the
       * NoImage fallback.
       */
      getFirstThumbnailFromOptionid: function(optionid) {
         if (!optionid) {
            return null;
         }
         var thumbs = this.thumbnailsStatic;
         // Prefer a non-noimage image for this option
         return (
            thumbs.find(function(thumbnail) {
               return (
                  thumbnail.get('data-optionid') === optionid.toString() &&
                  !thumbnail.hasAttribute('data-noimage')
               );
               // fall back to the a product-level image
            }) ||
            thumbs.find(function(thumbnail) {
               return thumbnail.get('data-optionid') === '0';
               // fall back to a noimage for this option
            }) ||
            thumbs.find(function(thumbnail) {
               return (
                  thumbnail.get('data-optionid') === optionid.toString() &&
                  thumbnail.hasAttribute('data-noimage')
               );
            })
         );
      },

      // Allows us to set an image by just clicking it instead of relying on
      // optionids.
      showProductImageByIndex: function(index) {
         var thumbs = this.thumbnailsStatic;

         var thumb = thumbs.find(function(thumbnail) {
            return thumbnail.get('data-image-index') === index.toString();
         });

         this.selectThumbnail(thumb);
      },

      getIndexOfThumbnail: function(thumbnail) {
         return this.thumbnails.indexOf(thumbnail);
      },

      /**
       * NOTE: Some options have multiple images. It's assumed that if you already
       * have a product image set for the option, we don't want to change the
       * displayed image.
       */
      setProductImage: function(optionid) {
         if (this.activeImageStatic.get('data-optionid') !== optionid.toString()) {
            this.selectThumbnail(this.getFirstThumbnailFromOptionid(optionid));
         }
      },
   });

   /*
    * Logic for the mobile image carousel
    */
   var ProductImageMobileHandler = new Class({
      initialize: function(initialIndex) {
         var slider = $E('.js_slider');
         var dotCount = $$('.js_slide').length;
         var dotContainer = $E('.js_dots');
         var dotContainerChildren = dotContainer.getChildren();

         if (App.guid360) {
            var mobileProduct360 = new Product360(
               $$('.slide-360 .product-360')[0],
               App.directory360,
               'mobile'
            );

            slider.addEventListener('after.lory.slide', function(e) {
               var turnOn360 = dotContainerChildren[e.detail.currentSlide].hasClass('dot-360');

               slider.toggleClass('slide-360-on', turnOn360);
               mobileProduct360.toggle(turnOn360);
            });
         }

         slider.addEventListener('before.lory.init', function() {
            dotContainerChildren[initialIndex].addClass('active');
         });

         slider.addEventListener(
            'after.lory.init',
            function(e) {
               dotContainerChildren.each(
                  function(dot) {
                     dot.addEventListener(
                        'click',
                        function(e) {
                           this.slideTo(dotContainerChildren.indexOf(dot));
                        }.bind(this)
                     );
                  }.bind(this)
               );
            }.bind(this)
         );

         slider.addEventListener('after.lory.slide', function(e) {
            dotContainerChildren.removeClass('active');
            dotContainerChildren[e.detail.currentSlide].addClass('active');
         });

         try {
            this.dotNavigationSlider = lory(slider, {
               rewindOnResize: false,
               initialIndex: initialIndex,
            });
         } catch (e) {
            // Throws an exception on IE 9
            disableImageSlider();
         }

         /**
          * IE 9 doesn't support the classList call the lory module uses, so
          * prevent this from breaking the page by falling back to the old one.
          */
         function disableImageSlider() {
            $('mobile-product-images').removeClass('visible-mobile');
            $('mobile-product-images').addClass('hidden-mobile');
            $('product-page-images').removeClass('hidden-mobile');
         }
      },

      /*
       * Public function to slide to an image
       */
      slideTo: function(index) {
         if (this.dotNavigationSlider) {
            this.dotNavigationSlider.slideTo(index);
         }
      },

      returnIndex: function() {
         if (this.dotNavigationSlider) {
            return this.dotNavigationSlider.returnIndex();
         }
      },
   });

   /**
    * A product page is really a group of products tied together by some specific
    * attributes.
    *
    * This is where we handle modifying the displayed product data so it reflects
    * what the user has selected.
    */
   var ProductPageDataModifier = (function() {
      // Setup the product page state.
      var productOptions = App.options;
      var isSingleOptionProduct = App.isSingleOptionProduct;
      var productcode = App.productcode;
      var defaultOptionid = App.displayOptionid;
      var isEnabled = App.productIsEnabled;

      var imageHandler = new ProductImageHandler(defaultOptionid);

      // Will be initialized later. The selected option requires some logic.
      var selectedOptionid = null;
      // Holds all the data required to display the selected option.
      var selectedOption = null;

      // This function takes an optionid and returns the product display data
      // associated with that optionid.
      var getProductData = function(optionid) {
         return productOptions.find(function(option) {
            return option.optionid === parseInt(optionid, 10);
         });
      };

      var setupSelectedOptionMeta = function(optionid) {
         selectedOptionid = optionid;
         selectedOption = getProductData(selectedOptionid);
         App.itemcode = Utils.constructItemcode(productcode, optionid);
         App.sku = Utils.constructSku(productcode, optionid);
         setSelectedOptionid(selectedOptionid);
      };

      // Setup quantity dropdown state
      var maxQuantityOptions = 5;
      // Quantity dropdown elements
      var qtyDropdownContainer = $E('.js-quantity-dropdown-container');
      let qtyDropdown = null;
      let qtySelections = null;

      when(qtyDropdownContainer, function() {
         qtyDropdown = qtyDropdownContainer.getElement('.dropdown-wrapper');
         qtySelections = qtyDropdown.getElements('.selection');
      });

      var getSelectedQuantity = function() {
         return qtyDropdown.getValue();
      };

      // Setup new option dropdown elements
      const attributeAxisNodes = Array.convert(document.querySelectorAll('[data-attribute-axis]'));
      const optionDropdowns = attributeAxisNodes.map(axis => {
         return axis.querySelector('.dropdown-wrapper');
      });

      // Setup old option dropdown elements
      var optionDropdownContainer = $E('.js-product-option-dropdown-container');
      var optionDropdown = null;
      when(optionDropdownContainer, function() {
         optionDropdown = optionDropdownContainer.getElement('.dropdown-wrapper');
      });

      // Our condition information is passed around through the title because
      // legacy reasons. We will get rid of it at some point.
      //
      // Until then, we scan the display names of products to set condition display
      // information.
      var productOptionDisplayNames = App.productOptionDisplayNames;
      var getOptionDisplayName = function(optionid) {
         return productOptionDisplayNames[optionid] || '';
      };

      var aStockNotice = $E('.a-stock-notice');
      var bStockNotice = $E('.b-stock-notice');
      var cStockNotice = $E('.c-stock-notice');

      var updateConditionNotice = function() {
         var optionDisplayName = getOptionDisplayName(selectedOptionid);

         aStockNotice.addClass('hidden');
         bStockNotice.addClass('hidden');
         cStockNotice.addClass('hidden');

         if (optionDisplayName.contains('A-Stock')) {
            aStockNotice.removeClass('hidden');
         } else if (optionDisplayName.contains('B-Stock')) {
            bStockNotice.removeClass('hidden');
         } else if (optionDisplayName.contains('C-Stock')) {
            cStockNotice.removeClass('hidden');
         }
      };

      const productSpecs = $$('.js-spec-data');
      var updateProductSpecifications = function() {
         productSpecs.each(function(el) {
            var isHidden = el.get('data-optionid') != selectedOptionid;
            el.toggleClass('hidden', isHidden);
         });
      };

      var quantityInputError = $E('.quantity-input-error');
      var clearQuantityInputErrors = function() {
         quantityInputError.addClass('hidden');
      };

      var readyToShipDiv = $$('.js-ready-to-ship');
      var showQuantityAvailable = function() {
         var available = selectedOption.avail;

         // Limited quantity
         readyToShipDiv.addClass('limited');
         /* Translators: %1 -> numProducts; */
         readyToShipDiv.set('text', _js('Only %1 left', available));
      };

      // The Add To Cart div's display logic requires JS to setup in the right
      // state.
      //
      // TODO: Don't require JS to setup the inital state.
      var limitedAvailThreshold = 15;
      var maxQuantityOptions = 5;
      var usOnlyDiv = $$('.js-us-only-div');
      var addToCartButton = $E('.js-add-to-cart-button');
      var intlBuyBoxDiv = $E('.js-intl-buy-box');

      when(addToCartButton, function() {
         addToCartButton.addEvent('click', function(ev) {
            ev.preventDefault();

            var productcode = selectedOption.productcode;
            var optionid = selectedOptionid;
            var quantity = getSelectedQuantity();
            var availInCountry = selectedOption.availCountry;
            var available = selectedOption.avail;
            var canAddToCart = available >= quantity;

            // Not sure how we'd get to this state but might as well not allow it.
            if (!optionid || !availInCountry) {
               return;
            }

            quantityInputError.toggleClass('hidden', canAddToCart);

            if (canAddToCart) {
               addProduct(productcode, optionid, quantity);
               recordAddToCart(selectedOption, getSelectedQuantity());
            } else {
               showQuantityAvailable();
            }
         });
      });

      when($E('.intl-buy-box-reject'), function(rejectLink) {
         rejectLink.addEvent('click', function(ev) {
            ev.preventDefault();
            intlBuyBox.disableAndThen(updateAddToCartDiv);
         });
      });

      var updateAddToCartDiv = function() {
         var isAvailCountry = selectedOption.availCountry;
         var numAvailable = selectedOption.avail;

         // Product is in stock
         const shippingWrapper = $$('.js-shipping-wrapper');
         if (numAvailable >= 1 && isAvailCountry) {
            shippingWrapper.removeClass('hidden');

            if (numAvailable <= limitedAvailThreshold) {
               showQuantityAvailable();
            } else {
               readyToShipDiv.removeClass('limited');
               readyToShipDiv.set('text', _js('Ready to Ship'));
            }

            addToCartButton.removeClass('hidden');
            addToCartButton.removeAttribute('disabled');

            qtyDropdownContainer.removeClass('hidden');
            qtyDropdown.removeAttribute('aria-disabled');

            usOnlyDiv.addClass('hidden');
            // Product can't be added b/c not avail in country
         } else if (!isAvailCountry) {
            usOnlyDiv.removeClass('hidden');

            addToCartButton.removeClass('hidden');
            addToCartButton.removeClass('button-action-solid');
            addToCartButton.setAttribute('disabled', '');

            qtyDropdownContainer.removeClass('hidden');
            qtyDropdown.setAttribute('aria-disabled', '');

            shippingWrapper.addClass('hidden');
            // Product can't be added b/c is out of stock
         } else {
            qtyDropdownContainer.addClass('hidden');
            shippingWrapper.addClass('hidden');
            addToCartButton.addClass('hidden');
         }

         // Update the Quantity Dropdown
         //
         // Don't show selections that are greater than what we have in stock
         if (numAvailable < maxQuantityOptions) {
            // Reset any previously hidden selections
            qtySelections.removeClass('hidden-option');

            qtySelections.each(function(el) {
               // Quantity dropdown only ever has numbers or '+'
               var dropdownVal = parseInt(el.getAttribute('title'), 10);
               if (isNaN(dropdownVal) || dropdownVal > numAvailable) {
                  el.addClass('hidden-option');
               }
            });
         } else {
            qtySelections.removeClass('hidden-option');
         }
         // The international store interface depends on a one-time extra
         // request, so its setup happens asynchronously once the request
         // completes, if its conditions are met.
         intlBuyBoxDiv.addClass('hidden');
         intlBuyBox.setupAndThen(selectedOptionid, intlBuyBoxDiv, function() {
            intlBuyBoxDiv.removeClass('hidden');

            addToCartButton.addClass('hidden');
            shippingWrapper.addClass('hidden');
            qtyDropdownContainer.addClass('hidden');
         });
      };

      var productPriceSpan = $$('.js-product-price');
      var regularPriceSpan = $$('.js-regular-price');
      var discountDiv = document.querySelectorAll('.js-discount-price');
      var itemcodeSpan = $$('.js-page-itemcode');

      var updateProductPriceDiv = function() {
         var itemcode = selectedOption.itemcode;

         // The user might have a discount, so their "purchase price" might be
         // different from the "regular" price. We use the latter to to
         // highlight any savings the customer gets.
         var userPriceText = selectedOption.purchasePriceText;
         var regularPriceText = selectedOption.retailPriceText;
         var isRetailPrice = selectedOption.isRetailPrice;

         productPriceSpan.set('text', userPriceText);
         regularPriceSpan.set('text', regularPriceText);

         // We show the discount UI if the user price is less than the retail
         // price.
         discountDiv.forEach(el => el.classList.toggle('hidden', isRetailPrice));

         itemcodeSpan.set('text', itemcode);

         // The active optionid is the `o` query param;
         // update it to the new optionid while keeping everything else the same.
         if (window.history.replaceState) {
            window.history.replaceState(
               /* state */ null,
               /* name */ itemcode,
               new URI(window.location.href).setData('o', selectedOptionid).toString()
            );
         }
      };

      // Uses the "selected" option data to update the product image.
      var updateProductImage = function() {
         imageHandler.setProductImage(selectedOptionid);
      };

      function selectionToOptionid(selection) {
         for (const optionid of Object.keys(App.optionidToSelection)) {
            let isMatch = true;
            let possibleMatchSelection = App.optionidToSelection[optionid];

            for (const axis of Object.keys(selection)) {
               if (selection[axis] !== possibleMatchSelection[axis]) {
                  isMatch = false;
                  break;
               }
            }

            if (isMatch) {
               return optionid;
            }
         }
      }

      function getAxisValueSelection() {
         const attributeAxisNodes = Array.convert(
            document.querySelectorAll('[data-attribute-axis]')
         );

         let currentSelection = attributeAxisNodes.reduce((selection, node) => {
            selection[node.getAttribute('data-attribute-axis')] = node
               .querySelector('.dropdown-wrapper')
               .getAttribute('data-value');
            return selection;
         }, {});

         return currentSelection;
      }

      function evaluateDropdownSelectedOptionid() {
         let currentSelection = getAxisValueSelection();
         return selectionToOptionid(currentSelection);
      }

      function chooseValidOption() {
         const attributeAxisNodes = Array.convert(
            document.querySelectorAll('[data-attribute-axis]')
         );
         let newOptionid;

         attributeAxisNodes.forEach(axisNode => {
            const dropdown = axisNode.querySelector('.dropdown-wrapper');
            var options = dropdown.getElements(
               '.options .selection:not(".more, .input-hidden-option")'
            );

            options.forEach(option => {
               if (
                  option.classList.contains('currently-selected-option') &&
                  option.classList.contains('invalid-option')
               ) {
                  const selectedOption = option.getAttribute('data-value');
                  const axis = axisNode.getAttribute('data-attribute-axis');

                  for (const optionid of Object.keys(App.optionidToSelection)) {
                     let selection = App.optionidToSelection[optionid];

                     // Find a valid selection with the currently selected option
                     if (selection[axis] == selectedOption) {
                        newOptionid = selectionToOptionid(selection);
                        return newOptionid;
                     }
                  }
               }
            });
         });

         return newOptionid;
      }

      function disableInvalidDropdownSelections(currentSelection, axis, options) {
         options.forEach(option => {
            currentSelection[axis] = option.getAttribute('data-value');

            if (!selectionToOptionid(currentSelection)) {
               option.classList.add('invalid-option');
            } else {
               // Make sure that there isn't a left over 'invalid-option' class applied
               option.classList.remove('invalid-option');
            }
         });
      }

      function updateDropdownDisplay() {
         const selection = App.optionidToSelection[selectedOptionid];

         const attributeAxes = selection ? Object.keys(selection) : [];

         attributeAxes.forEach(axis => {
            const newValue = selection[axis];
            const dropdownNode = document.querySelector(`[data-attribute-axis="${axis}"]`);
            const dropdown = dropdownNode.querySelector('.dropdown-wrapper');
            var options = dropdown.getElements(
               '.options .selection:not(".more, .input-hidden-option")'
            );
            var newOption;

            for (var i = 0; i < options.length; i++) {
               if (options[i].getAttribute('data-value') === newValue) {
                  newOption = options[i];
                  break;
               }
            }

            selectDropdownOption(dropdown, newOption);

            var newSelectedValue = newOption.getAttribute('data-value') || value;
            var newSelectedTitle = newOption.title || newSelectedValue;

            dropdown.set('data-value', newSelectedValue);
            dropdown.getElement('.selected').title = newSelectedTitle;

            dropdown.getElement('.selected strong').set('text', newSelectedTitle);

            var dropdownInput = dropdown.getElement('.js-dropdown-input');
            dropdownInput.value = newSelectedValue;

            disableInvalidDropdownSelections({ ...selection }, axis, options);
         });
      }

      function selectDropdownOption(dropdown, domOption) {
         var currentlySelectedOption = dropdown.getElement('.currently-selected-option');

         if (currentlySelectedOption) {
            currentlySelectedOption.removeClass('currently-selected-option');
         }

         if (domOption) {
            domOption.addClass('currently-selected-option');
         }

         return domOption;
      }

      // Show the product details associated with the selected option
      const updateProductDetails = function() {
         const selector = '.js-option-details';
         $$(selector).addClass('hidden');
         $$(`${selector}[optionid=${selectedOptionid}]`).removeClass('hidden');
      };

      var displayProductOption = function(optionid) {
         // Do nothing if we've already selected the optionid.
         if (optionid == selectedOptionid) {
            return;
         }

         if (isEnabled) {
            setupSelectedOptionMeta(optionid);
            clearQuantityInputErrors();

            updateDropdownDisplay();
            updateConditionNotice();
            updateProductSpecifications();
            updateAddToCartDiv();
            updateProductPriceDiv();
            updateProductDetails();

            updateProductImage();
            // We currently don't support recording viewing disabled products.
            // There's no data like price associated with it and the item code
            // will always be the "default" one.
            //
            // If we wanted to support viewing disabled products we'd have to
            // figure out a different action.
            recordProductView(selectedOption);
         }
      };

      // Setup Option dropdown events
      if (optionDropdowns.length > 0) {
         optionDropdowns.forEach(optionDropdown => {
            optionDropdown.addEvent('valuechanged', function(ev) {
               /* setTimeout is used here to ensure that the dropdown has time
                * to update before evaluating the selected option id based
                * off the dropdown state. Without setTimeout, the previous
                * dropdown state is evaluated, producing incorrect results
                */
               setTimeout(() => {
                  const optionid = evaluateDropdownSelectedOptionid() || chooseValidOption();
                  displayProductOption(optionid);
               }, 0);
            });
         });
      }

      $$('.js-image-select-option').addEvent('click', function(ev) {
         // If they clicked on a non-default picture we want to make sure the
         // picture they clicked on is hightlighted.
         imageHandler.showProductImageByIndex(ev.target.get('data-image-index'));
         // "Default" images aren't associated with an optionid, so they have an
         // optionid of 0.
         // We don't want to change the selected option values, just update the
         // image.
         if (ev.target.get('data-optionid') != 0) {
            displayProductOption(ev.target.get('data-optionid'));
         }
      });

      // Akeneo data is all going to follow the same data structure to be updated.
      // They all have "data-product-attribute" with a index that we will look up
      // and update with the product specific value.
      var getAttributeElements = function(attributeName) {
         return $$('[data-product-attribute="' + attributeName + '"]');
      };

      // The product page has to be initialized through JS to display correctly.
      // Note: it gets initialized on domready as well, so we need to wait a
      // tick before trying to talk to it.
      setTimeout(function() {
         displayProductOption(App.optionid);
      }, 0);

      // If we add a product to the cart but don't redirect, we need to update the
      // availibility the user can put in their cart.
      var updateProductOptionAvailability = function(optionid, newAvailability) {
         productOptions.each(function(entry) {
            if (entry.optionid === parseInt(optionid, 10)) {
               entry.avail = newAvailability;
            }
         });

         // The set option data needs to be refreshed now that we've changed it.
         if (optionid == selectedOptionid) {
            setupSelectedOptionMeta(optionid);
            updateAddToCartDiv();
         }
      };

      return {
         updateProductOptionAvailability: updateProductOptionAvailability,
      };
   })();

   window.ProductViewPage = {
      updateAvailability: ProductPageDataModifier.updateProductOptionAvailability,
   };
});
